import React, { useState } from "react";
import styled from "styled-components";

// import {
//   FaFacebookF,
//   FaTwitter,
//   FaPinterest,
//   FaInstagram,
//   FaPlay,
// } from "react-icons/fa";
// const Contact = () => {
//   return (
//     <div className="contact">
//       <div className="container">
//         <div className="contactSection">
//           <div className="row justifyConter">
//             <div className="col-6">
//               <div className="contactSection-logo">
//                 <img src="/images/logo.png" alt="" />
//               </div>
//               <p>
//                 Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
//                 eiusmod tempor inci- didunt ut labore et dolore magna aliqua. Ut
//                 enim ad minim veniam, quis nostrud exe- rcitation ullamco
//                 laboris nisi ut aliquip ex ea commodo consequat.
//               </p>
//               {/* <ul className="contactCircles">
//                 <li>
//                   <a href="https://www.facebook.com/profile.php?id=100027146681035">
//                     <FaFacebookF className="contactIcon" />
//                   </a>
//                 </li>
//                 <li>
//                   <FaTwitter className="contactIcon" />
//                 </li>
//                 <li>
//                   <FaPinterest className="contactIcon" />
//                 </li>
//                 <li>
//                   <FaInstagram className="contactIcon" />
//                 </li>
//               </ul> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;

const Contact = () => {
  return (
    <div className="contact">
      <div className="container">
        <div className="contactSection">
          <div className="row justifyCenter">
            <div className="col-6">
              <h2 className="contactHead">Feel Free to Contact me </h2>

              <div className="container2">
                <div className="contact-form">
                  <form 
                    action="https://formspree.io/f/mpzeaene"
                    method="POST"
                    className="contact-inputs"
                  >
                    <input
                      type="text"
                      name="username"
                      placeholder="Your Name"
                      autoComplete="off"
                      required
                      className="input1"
                    />
                    <input
                      type="email"
                      name="Email"
                      placeholder="Your Email"
                      autoComplete="off"
                      required
                      className="input1"
                    />

                    <textarea
                      name="message"
                      id=""
                      cols="30"
                      rows="8"
                      autoComplete="off"
                      placeholder="Enter your message here "
                      required
                      className="textarea1"
                    ></textarea>

                    <input type="submit" value="Send" className="submit1" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
